import { PoolScope } from "./pool.models";
import { cloneDeep } from 'lodash-es'; // Ensure this is imported correctly
import SportEvent = PoolScope.SportEvent;

export function enrichPoolData(pool: PoolScope.CurrentPool | null, sportEvents: SportEvent | null): PoolScope.CurrentPool | null {
  // Defensive checks
  if (!pool || !pool.legs || !sportEvents) {
    return pool;
  }

  // 1. CRITICAL FIX: Use cloneDeep to ensure the entire nested structure is copied
  const enrichedPool = cloneDeep(pool);

  const eventsArray = Array.isArray(sportEvents) ? sportEvents : [sportEvents];
  const sportEventsMap = new Map(
    eventsArray.filter(ev => !!ev).map((se: any) => [se.id, se])
  );

  // 2. Apply your original, working logic to the CLONED object
  enrichedPool.legs.forEach((leg) => {
    try {
      if (!leg.selections) {
        return;
      }

      // Note: Because we used cloneDeep(pool), 'leg' and 'selection' are safe copies.
      leg.selections.forEach((selection) => {
        try {
          const player = selection.player;
          if (!player?.sport_event_id) {
            return;
          }

          const matchingSportEvent: any = sportEventsMap.get(player.sport_event_id);

          if (!matchingSportEvent) {
            console.warn('No sport event found for player sport_event_id:', player.sport_event_id);
            return; // Skip enrichment for this selection
          }

          // Original logic check
          if (!matchingSportEvent.sport_event_competitors) {
            console.warn('Sport event missing competitors:', matchingSportEvent.id);
            player.at_home = false;
            return; // Skip enrichment for this selection
          }

          // Original logic check
          // if (!matchingSportEvent?.sport_event_competitors) {
          //   // Still ensure a default on the CLONED player object
          //   player.at_home = false;
          //   return;
          // }

          // MERGE/MUTATION on the CLONED objects:
          selection.sport_event = matchingSportEvent;
          leg.parsed_sport_code = matchingSportEvent.sport_code;

          let homeCompetitor: any = null;
          let awayCompetitor: any = null;
          let playerCompetitor: any = null;

          for (const competitor of matchingSportEvent.sport_event_competitors) {
            // Original logic: ensure home/away is only set once per status type
            if (competitor.status === 'Home') {
              homeCompetitor = homeCompetitor || competitor;
            } else if (competitor.status === 'Away') {
              awayCompetitor = awayCompetitor || competitor;
            }

            // Match the player's competitor
            if (player.sport_event_competitor_id === competitor.id) {
              playerCompetitor = competitor;
            }

            // Optimization from original logic
            if (homeCompetitor && awayCompetitor && playerCompetitor) {
              break;
            }
          }

          // Attach home/away team on the selection (Mutation on cloned object)
          if (homeCompetitor) {
            selection.home_team = homeCompetitor;
          }
          if (awayCompetitor) {
            selection.away_team = awayCompetitor;
          }

          // Default at_home (Mutation on cloned object)
          player.at_home = undefined;

          // Final at_home logic
          if (playerCompetitor) {
            player.at_home = playerCompetitor.status === 'Home';
          }
          // Fallback logic
          if (player.at_home === undefined) {
            player.at_home = false;
          }

        } catch (selectionError) {
          // If error occurs, set fallback on the cloned selection/player
          if (selection.player) {
            selection.player.at_home = false;
          }
        }
      });
    } catch (legError) {
      // Handle leg error if necessary
    }
  });
  return enrichedPool; // Return the fully enriched, pure copy
}
